// extracted by mini-css-extract-plugin
export default {"wrapper":"FaqListItem_wrapper__UdnnS","trigger":"FaqListItem_trigger__UzjPk","trigger--open":"FaqListItem_trigger--open__xojpe","content":"FaqListItem_content__e5fE+"};